module.exports = __webpack_public_path__ + "img/pic_dontmissout_card@3x.eb184054.png";